export default {"src":"/_next/static/media/warning.42d8cafb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};